///////////////////////////////////
// IMPORTS
///////////////////////////////////
// constants
import { paths } from "@clockwise/client-commons/src/constants/site";

// util
import { getServerUrl } from "@clockwise/web-commons/src/util/post-message-common.util";
import { generateNonce } from "@util/third-party-oauth.util";
// import { logger } from "@util/logger.util";

// state
import { m365Nonce } from "@state/local-storage";

///////////////////////////////////
// Types
///////////////////////////////////
export const M365_AUTH_COMPLETE_MESSAGE = "cw-m365-auth-complete";

export interface IM365AuthCompleteMessageData {
  message: string;
  success: boolean;
  authCode?: string;
}

///////////////////////////////////
// App setup
///////////////////////////////////
function getMicrosoftClientId() {
  switch (process.env.ENVIRONMENT) {
    case "production":
      return "52d932e1-6ff8-4730-87b3-27544063a3ad";
    case "staging":
      return "0082c14b-42bd-4258-abf4-543b931bfbf9";
    default:
      return "5a4122b5-63ee-4bf2-a582-cb3625d1cd31";
  }
}

function generateNonceAndStoreForM365() {
  const nonce = generateNonce();
  m365Nonce.set(nonce);
  return nonce;
}

export function getMicrosoftAuthUrl() {
  const GRAPH = "https://graph.microsoft.com";
  const SCOPES = [
    GRAPH + "/Calendars.ReadWrite.Shared",
    GRAPH + "/Directory.AccessAsUser.All",
    GRAPH + "/User.Read",
    GRAPH + "/User.ReadBasic.All",
    "offline_access",
  ];
  const SCOPE_STRING = SCOPES.join(" ");

  const redirectUri = `${getServerUrl()}${paths.microsoftAuthRedirect}`;

  const params = new URLSearchParams();
  params.set("client_id", getMicrosoftClientId());
  params.set("response_type", "code");
  params.set("redirect_uri", redirectUri);
  params.set("response_mode", "query");
  params.set("resource", GRAPH);
  params.set("scope", SCOPE_STRING);
  params.set("state", generateNonceAndStoreForM365());

  const microsoftAuthBaseUrl = "https://login.microsoftonline.com/common/oauth2/authorize";
  const microsoftAuthUrl = `${microsoftAuthBaseUrl}?${params.toString()}`;
  return microsoftAuthUrl;
}
